
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/[slug]",
      function () {
        return require("private-next-pages/journal/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journal/[slug]"])
      });
    }
  